import {
    FETCH_TAXENTITYLIST_BEGIN, FETCH_TAXENTITYLIST_SUCCESS, FETCH_TAXENTITYLIST_FAILURE,
    FETCH_TAXENTITYDETAIL_FAILURE, FETCH_TAXENTITYDETAIL_SUCCESS, FETCH_TAXENTITYDETAIL_BEGIN,
    FETCH_INVESTORACTIVITYDETAIL_BEGIN, FETCH_INVESTORACTIVITYDETAIL_SUCCESS, FETCH_INVESTORACTIVITYDETAIL_FAILURE,
    FETCH_RELATEDCONTACT_BEGIN, FETCH_RELATEDCONTACT_SUCCESS, FETCH_RELATEDCONTACT_FAILURE,
    FETCH_RELATIONTYPES_BEGIN, FETCH_RELATIONTYPES_SUCCESS, FETCH_RELATIONTYPES_FAILURE,


} from "../constants/investorAccount";


const initialState={
    taxEntityList:[],
    isTaxEntityListLoading:false,
    taxEntityListerror:null,
    taxEntityDetail:{},
    isTaxEntityDetailLoading:false,
    taxEntityDetailerror: null,
    InvestorActivitiesDetails:[],
    isInvestorActivitiesDetailsLoading: false,
    taxInvestorActivitiesDetailserror: null,

    isRelatedContactLoading: false,
    RelatedContact: [],
    RelatedContacterror: null,

    RelationTypes: [],
    RelationTypeserror: null,
    isRelationTypesLoading: false,

}


export const getInvestorAccountListReducer = (state = initialState, action) => {
  
    const { type, payload } = action;
    // if(type===FETCH_TAXENTITYDETAIL_SUCCESS)
    // {
    //     debugger;
    // }
    switch (type) {
        case FETCH_TAXENTITYLIST_BEGIN:
            return {
                ...state,
                isTaxEntityListLoading: true,
                taxEntityList:[],
                TaxEntityListerror:null,
            };
        case FETCH_TAXENTITYLIST_SUCCESS:
            return {
                ...state,
                isTaxEntityListLoading: false,
                taxEntityList:payload.investorAccountsList,
                TaxEntityListerror:null,
            };
        case FETCH_TAXENTITYLIST_FAILURE:
            return {
                ...state,
                isTaxEntityListLoading: false,
                TaxEntityListerror: payload.errorMessage,
                taxEntityList:[],
            };
        case FETCH_TAXENTITYDETAIL_BEGIN:
            return {
                ...state,
                isTaxEntityDetailLoading: true,
                taxEntityDetail: {},
                taxEntityDetailerror:null,
            };
        case FETCH_TAXENTITYDETAIL_SUCCESS:
            return {
                ...state,
                isTaxEntityDetailLoading: false,
                taxEntityDetail: payload.investorAccountDetail,
                taxEntityDetailerror:null,
            };
        case FETCH_TAXENTITYDETAIL_FAILURE:
            return {
                ...state,
                isTaxEntityDetailLoading : false,
                taxEntityDetail: {},
                taxEntityDetailerror:payload.errorMessage,
            };

        case FETCH_INVESTORACTIVITYDETAIL_BEGIN:
            return {
                ...state,
                isInvestorActivitiesDetailsLoading: true,
                taxEntityDetail: {},
                InvestorActivitiesDetailserror: null,
            };
        case FETCH_INVESTORACTIVITYDETAIL_SUCCESS:
            return {
                ...state,
                isInvestorActivitiesDetailsLoading: false,
                InvestorActivitiesDetails: payload.InvestorActivitiesDetails,
                InvestorActivitiesDetailserror: null,
            };
        case FETCH_INVESTORACTIVITYDETAIL_FAILURE:
            return {
                ...state,
                isInvestorActivitiesDetailsLoading: false,
                InvestorActivitiesDetails: [],
                InvestorActivitiesDetailsrror: payload.errorMessage,
            };

        case FETCH_RELATEDCONTACT_BEGIN:
            return {
                ...state,
                isRelatedContactLoading: true,
                RelatedContact: {},
                RelatedContacterror: null,
            };
        case FETCH_RELATEDCONTACT_SUCCESS:
            return {
                ...state,
                isRelatedContactLoading: false,
                RelatedContact: payload.RelatedContact,
                RelatedContacterror: null,
            };
        case FETCH_RELATEDCONTACT_FAILURE:
            return {
                ...state,
                isRelatedContactLoading: false,
                RelatedContact: [],
                RelatedContacterror: payload.errorMessage,
            };


        case FETCH_RELATIONTYPES_BEGIN:
            return {
                ...state,
                isRelationTypesLoading: true,
                RelationTypes: {},
                RelationTypeserror: null,
            };
        case FETCH_RELATIONTYPES_SUCCESS:
            return {
                ...state,
                isRelationTypesLoading: false,
                RelationTypes: payload.RelationTypes,
                RelationTypeserror: null,
            };
        case FETCH_RELATIONTYPES_FAILURE:
            return {
                ...state,
                isRelationTypesLoading: false,
                RelationTypes: [],
                RelationTypeserror: payload.errorMessage,
            };



        default :
        return state;
    }
}
